export const selectTranslationsLoading = (state) => state.translations.loading;
export const selectTranslationsError = (state) => state.translations.error;
